import React from 'react'
import AboutUs from '../about-us'

const AboutUsDa = () => {
    return <AboutUs languageCode="da" />
}

export default AboutUsDa
